import React, { useState, useEffect } from 'react'

const getScreenWidth = () => document.body.clientWidth

const ShowForScreenWidth = ({ max, min, children }) => {
  const [clientWidth, setClientWidth] = useState(getScreenWidth())

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  })

  const handleResize = () => setClientWidth(getScreenWidth())

  if (min && clientWidth >= min) {
    return <>{children}</>
  }

  if (max && clientWidth <= max) {
    return <>{children}</>
  }

  return null;
}

export default ShowForScreenWidth
